import React from "react";
import { node } from "prop-types";
import releaseNotesApp from "@insightfulscience/contentful/Apps/ReleaseNotes";
import { WithLocale } from "@insightfulscience/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "@src/SiteLayout";
import SectionTryForFree from "@src/SectionTryForFree";
import { withErrorHandling } from "@src/AppError";

import PageMeta from "@insightfulscience/smart-react/PageMeta";
import updates from "../../locales/updates-page";

const ReleaseNotesLayout = ({ children }) => {
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.OGP
					image="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					imageSecureUrl="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					isImageBaseUrl
				/>
				<PageMeta.Twitter
					image="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					isImageBaseUrl
				/>
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

ReleaseNotesLayout.propTypes = {
	children: node.isRequired,
};

export default pipe(
	releaseNotesApp({
		Layout: ReleaseNotesLayout,
		contentfulProps: {
			environment: process.env.CTF_ENV,
			space: process.env.CTF_SPACE,
			accessToken: process.env.CTF_TOKEN,
			proxy: null,
		},
		pageProps: {
			brandCode: "sg",
			siteDomain: "https://www.snapgene.com",
		},
	}),
	WithLocale({ resources: updates }),
	withErrorHandling,
);
